import React from 'react'
import RowItem from './item'
import { ITEM_TYPES } from '@/constants'

export const prepareTreeData = (rows, download, localize, locale) => {
  const processRows = (download, items) => {
    if (items && items.length > 0) {
      return items.map(item => {
        return {
          title: (
            <RowItem
              title={item.title}
              id={item.id}
              type={(item.itemType === ITEM_TYPES.CHAPTER ? 'chapter' : 'document')}
              localize={localize}
              locale={locale}
              download={download}
              file={item.file}
            />
          ),
          children: processRows(download, item.children),
          expanded: item.expanded
        }
      })
    }
    return null
  }

  const data = []

  if (rows) {
    const children = processRows(download, rows)
    if (children) { children.forEach(row => data.push(row)) }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/components/documentationViewer/dataSource/index.js